import { modMap, regionStyle } from "./helper";

jQuery(function ($) {
  if ($(".page-node-type-country, #country-detail-map").length > 0) {
    console.log("country-detail-map Ready");

    var theMap = $("#country-detail-map");

    const countryCode = theMap.data("code");

    if (
      countryCode === undefined ||
      countryCode === null ||
      countryCode === ""
    ) {
      return;
    }

    let timeoutVar;

    theMap.vectorMap({
      map: "world_mill",
      backgroundColor: "#F9F9FB",
      panOnDrag: true,
      zoomAnimate: true,
      zoomOnScroll: false,
      focusOn: { region: countryCode },
      regionStyle: regionStyle,
      onRegionClick: function (e, code) {
        e.preventDefault();
      },
      onRegionOver: function (e, code) {
        e.preventDefault();
      },
      onRegionOut: function (e, code) {
        e.preventDefault();
      },
      onRegionTipShow: function (e) {
        e.preventDefault();
        return false;
      },
      onViewportChange: function (e, scale) {
        e.preventDefault();
      },
      onMarkerTipShow: function (e, o, s) {
        e.preventDefault();
      },
      onMarkerOver: function (e, s) {
        e.preventDefault();
      },
      onMarkerOut: function (e, s) {
        e.preventDefault();
      },
    });

    var myMap = theMap.vectorMap("get", "mapObject");

    myMap.regions[countryCode].element.config.style.selected.fill = "#004587";
    myMap.setSelectedRegions(countryCode);

    modMap(theMap);

    $(window).on("resize", function () {
      const ww = $(window).width();

      clearTimeout(timeoutVar);

      timeoutVar = setTimeout(() => {
        myMap.setFocus({ region: countryCode });
      }, 100);
    });
  }
});
